import React from "react"
import CurveWrapper from "components/CurveWrapper"
import TextSection from "../TextSection"

class Problem extends React.Component {
  render() {
    const textSection = () => (
      <TextSection variant="dark">
        <section>
          <h2>Problemet</h2>
          {this.props.renderProblem()}
        </section>
      </TextSection>
    )

    return this.props.wrap ? (
      <CurveWrapper backgroundColor="#2f3542">{textSection()}</CurveWrapper>
    ) : (
      textSection()
    )
  }
}

export default Problem



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Problem/index.jsx